module.exports = __webpack_public_path__ + "img/clapperboard-play.9292f8db.svg";